'use client'

import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react'
import { PropsWithChildren, useEffect, useState } from 'react';
import { isIOS } from '../../Utils/Helpers';

interface ModalProps {
    open: boolean;
    closeable?: boolean;
    onClose: CallableFunction;
    className?: string;
    rounded?: boolean;
}

const Modal = ({
        children,
        open = false,
        closeable = true,
        onClose = () => {},
        className = '',
        rounded = true
    }: PropsWithChildren<ModalProps>) => {

    const [scaleNotCloseable, setScaleNotCloseable] = useState(false)
    const [scale, setScale] = useState('')
    const close = () => {
        if (closeable) {
            onClose();
        } else {
            setScaleNotCloseable(true)
        }
    };

    useEffect(() => {
        setScale('scale-110');
        setTimeout(() => {
        setScale('scale-100');
        setScaleNotCloseable(false)
        }, 50);
    }, [scaleNotCloseable])

    useEffect(() => {

        const handlePopState = () => {
            if (open) {
                onClose();
            }
        };

        window.addEventListener('popstate', handlePopState);

        if (!window.history.state) {
            // estado base
            window.history.replaceState({ page: 'base' }, '');
            // estado do modal
            window.history.pushState({ modal: true }, '');
        } else if (!window.history.state?.modal) {
            // navegação interna normal
            window.history.pushState({ modal: true }, '');
        }

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    //* Utilizado no iOS para retornar sem animação de fechamento e não afetar outros componentes.
    if (!open && isIOS()) return null;

    return (
        <Dialog open={open} onClose={close} className="relative z-50">
            <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-800/60 backdrop-blur-sm transition-opacity data-[closed]:opacity-0 data-[enter]:duration-150 data-[leave]:duration-150 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <div className="fixed inset-0 bottom-0 z-10 w-screen overflow-y-auto h-dvh min-h-dvh">
                <div className="flex min-h-full items-end justify-center text-center items-center">
                    <DialogPanel
                        transition
                        className={`
                            ${scale}
                            ${className}
                            relative transform overflow-hidden bg-white shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-150 data-[leave]:duration-150 data-[enter]:ease-out data-[leave]:ease-in data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95
                            w-full
                            ${rounded && 'rounded-2xl'}
                        `}
                    >
                        {children}
                    </DialogPanel>
                </div>
            </div>
        </Dialog>
    )
}

export default Modal;